module.exports = __webpack_public_path__ + "img/content.76e8716e.png";